import axios from "axios";
import router from "@/router";
import Helper from "./services/helper";

// Helper.logout() itself POSTs /logout, whose response also flows through
// this interceptor. Without excluding it, a device-mismatched session would
// loop forever: logout's own "still mismatched" response would re-trigger
// logout, whose response would re-trigger logout, etc.
let loggingOut = false;

axios.interceptors.response.use(
  function (response) {
    if (response.data.success === false) {
      if (
        response.data.message ===
          "Unauthorized - User is already logged in another device." &&
        !response.config?.url?.includes("/logout") &&
        !loggingOut
      ) {
        loggingOut = true;
        Helper.logout().finally(() => {
          loggingOut = false;
        });
        if (router.currentRoute.name != "NotAllowed") {
          router.push("/not-allowed");
        }
      }
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
